import React, { useState } from "react";
import { Search, X } from "lucide-react";

/**
 * Compact search input rendered above chat / DM threads.
 * Filters the visible message list client-side via the `onQuery` prop.
 * The parent decides how to render results.
 */
export default function SearchBar({ onQuery, placeholder = "Search this conversation…", testid = "search-bar" }) {
  const [q, setQ] = useState("");

  const handleChange = (e) => {
    const next = e.target.value;
    setQ(next);
    onQuery && onQuery(next);
  };

  const clear = () => { setQ(""); onQuery && onQuery(""); };

  return (
    <div className="relative flex items-center gap-2 px-3 py-2 border-b border-white/10 bg-panel/30" data-testid={testid}>
      <Search className="w-4 h-4 text-white/40 shrink-0" />
      <input
        value={q}
        onChange={handleChange}
        placeholder={placeholder}
        className="flex-1 bg-transparent border-0 focus:outline-none font-mono text-xs text-white/80 placeholder:text-white/30"
        data-testid={`${testid}-input`}
      />
      {q && (
        <button
          type="button"
          onClick={clear}
          className="text-white/40 hover:text-blaze"
          data-testid={`${testid}-clear`}
          title="Clear"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
